import { Button, Checkbox, Group, Modal, Stack, Text } from "@mantine/core";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { setExcludeFinishedTasksInRedux } from "../meetingSlice";

interface ConfirmGenerateDocxModalProps extends ConfirmModalContentProps {
  opened: boolean;
}

interface ConfirmModalContentProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmGenerateDocxModal: React.FC<ConfirmGenerateDocxModalProps> = ({ onConfirm, onCancel, opened }) => {
  return (
    <Modal opened={opened} onClose={onCancel} title="Generer møtereferat" centered size="md">
      <ConfirmModalContent onConfirm={onConfirm} onCancel={onCancel} />
    </Modal>
  );
};

export default ConfirmGenerateDocxModal;

const ConfirmModalContent: React.FC<ConfirmModalContentProps> = ({ onConfirm, onCancel }) => {
  const dispatch = useAppDispatch();

  const selectedTemplate = useAppSelector((state) => state.meetingReducer.selectedDocxTemplate);
  const excludeFinishedTasks = useAppSelector((state) => state.meetingReducer.excludeFinishedTasks);

  return (
    <Stack>
      <Text>Du er i ferd med å generere et dokument basert på malen:</Text>
      <Text fw={500}>{selectedTemplate?.fileName}</Text>
      <Checkbox
        label="Ekskluder fullførte oppgaver i hvert agendapunkt"
        checked={excludeFinishedTasks}
        onChange={(e) => dispatch(setExcludeFinishedTasksInRedux(e.currentTarget.checked))}
        mt="md"
      />
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onCancel}>
          Avbryt
        </Button>
        <Button color="blue" onClick={onConfirm}>
          Bekreft
        </Button>
      </Group>
    </Stack>
  );
};
